// FullPageLoader.jsx
import React, { Component } from "react";
import KidoLoader from "../common/KidoLoader";

class FullPageLoader extends Component {
  render() {
    return <KidoLoader overlay label="Working on it" />;
  }
}

export default FullPageLoader;
